const SignInModel = {};

SignInModel.POPUP_VIEWS = {
  SIGN_IN: 'signIn',
  JOIN: 'join',
  FORGOT_PASSWORD: 'forgotPassword',
  NEW_PASSWORD: 'newPassword',
  NEW_PASSWORD_PRO: 'newPasswordPro',
};

export default SignInModel;
